import { Component } from 'react';
import PropTypes from 'prop-types';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
/**
 * Usage:
 *   <ErrorBoundary boundaryName="MyComponent_MyError" renderError={() => <MyError />}}>
 *     <MyComponent />
 *   </ErrorBoundary>
 */
class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      caughtError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      caughtError: true
    };
  }
  componentDidCatch(error, info) {
    const {
      boundaryName
    } = this.props;
    const errorWithInfo = error;
    errorWithInfo.info = JSON.stringify(info);
    reportError({
      error: errorWithInfo,
      tags: {
        errorBoundaryName: boundaryName
      }
    });
  }
  render() {
    const {
      children,
      renderError
    } = this.props;
    const {
      caughtError
    } = this.state;
    if (caughtError) {
      return renderError(caughtError);
    }
    return children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node,
  renderError: PropTypes.func.isRequired,
  boundaryName: PropTypes.string
};
ErrorBoundary.defaultProps = {
  boundaryName: ''
};
export default ErrorBoundary;